import { render, staticRenderFns } from "./JdOrderDetail.vue?vue&type=template&id=97f00332&scoped=true"
import script from "./JdOrderDetail.vue?vue&type=script&lang=js"
export * from "./JdOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./JdOrderDetail.vue?vue&type=style&index=0&id=97f00332&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f00332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f00332')) {
      api.createRecord('97f00332', component.options)
    } else {
      api.reload('97f00332', component.options)
    }
    module.hot.accept("./JdOrderDetail.vue?vue&type=template&id=97f00332&scoped=true", function () {
      api.rerender('97f00332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/jdOrderList/components/JdOrderDetail.vue"
export default component.exports